import * as process from "process";
import { parseCookie } from "~/libs/cookie";

const maxAge = 60 * 60 * 24 * 31;

export class AccessTokenStorage {
  event: any;
  key = "token";

  constructor(event = null) {
    if (import.meta.server) {
      this.event = event;
    }
  }

  get(): string {
    let token = undefined;
    let cookiesStr;
    if (this.event) {
      cookiesStr = this.event.node.req.headers.cookie || "";
    } else {
      cookiesStr = document?.cookie;
    }
    const cookies = parseCookie(cookiesStr);
    token = cookies[this.key];
    return token;
  }

  set(value: string) {
    if (this.event) {
      const domain = process.env.COOKIE_HOST || 'localhost';
      this.event.node.res.appendHeader("Set-Cookie", `token=${value}; Max-Age=${maxAge}; Domain=${domain}; Path=/`);
    }
  }
  setCookie(name: string, value: string, httpOnly = false) {
    if (this.event) {
      const domain = process.env.COOKIE_HOST || 'localhost';
      this.event.node.res.appendHeader("Set-Cookie", `${name}=${value}; Max-Age=${maxAge}; Domain=${domain}; Path=/${httpOnly ? "; HttpOnly" : ""}`);
    }
  }
  remove(value: string) {
    if (this.event) {
      const domain = process.env.COOKIE_HOST || 'localhost';
      this.event.node.res.appendHeader("Set-Cookie", `token=${value}; Max-Age=-1; Domain=${domain}; Path=/`);
    }
  }
}
